export function arraysAreEqual(array1: unknown[], array2: unknown[]) {
  const set1 = new Set(array1);
  const set2 = new Set(array2);

  const areEqual =
    array1.length === array2.length && set1.size === set2.size && [...set1].every((value) => set2.has(value));

  return areEqual;
}
